/* istanbul ignore file */
import {CustomCssVarsFn} from '@wix/yoshi-flow-editor';
import {baseCustomCssVars} from '../../baseCustomCssVars';
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {createStylesParams, StyleParamType} from '@wix/tpa-settings';
import {baseStylesParams, galleryColumnsDefaultValue} from '../../styleParams/baseStylesParams';
import {IStylesParams, StylesParamKeys} from '../../styleParams/types';
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver';

export const customCssVars: CustomCssVarsFn = (params: CustomCssVarsFnParams) => {
  return {
    ...baseCustomCssVars(params),
  };
};

const stylesParams: IStylesParams = {
  ...baseStylesParams,
  galleryColumns: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: galleryColumnsDefaultValue,
    metadata: {
      type: StyleType.UNKNOWN_CssPropertyType,
      defaultValue: {
        type: 'static',
        value: 4,
      },
      mobileDefaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  gallery_layoutVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
    metadata: {
      type: StyleType.padding,
      defaultValue: {
        type: 'static',
        value: 16,
      },
    },
  },
};

export default createStylesParams<StylesParamKeys>(stylesParams);
